// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"47":"12133a47f5e0e715","888":"19e88371a03f4f0e"}[chunkId] + ".css";
};